import React from 'react';

import styles from './styles.module.css';

interface LabelsProps {
  children: React.ReactNode;
  color: 'normal' | 'dark';
  size: 'small' | 'medium' | 'big';
  bold?: boolean;
}

const Labels: React.FC<LabelsProps> = ({
  size = 'small',
  color = 'normal',
  bold = false,
  children
}) => {
  const labelClass = `${styles.label} 
   ${color === 'normal' && styles.normalColor}
   ${color === 'dark' && styles.darkColor} 
   ${size === 'small' && styles.smallSize} 
   ${size === 'medium' && styles.mediumSize} 
   ${size === 'big' && styles.bigSize}
   ${bold && styles.bold}`;

  return (
    <label id={`${children}-label`} className={labelClass}>
      {children}
    </label>
  );
};

export default Labels;
